var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingTransaction({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 55,
    viewBox: "0 0 65 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2816",
    "data-name": "Group 2816",
    transform: "translate(-710 -264)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_930",
    "data-name": "Rectangle 930",
    width: 65,
    height: 55,
    rx: 5,
    transform: "translate(710 264)",
    fill: "rgba(243,227,66,0.15)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3131",
    "data-name": "Path 3131",
    d: "M425.131,69.149a12.982,12.982,0,1,1-12.982-12.982A12.987,12.987,0,0,1,425.131,69.149Z",
    transform: "translate(330.41 222.373)",
    fill: "#d9cb2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3132",
    "data-name": "Path 3132",
    d: "M414.9,72.093l-4.024-2.4a2.875,2.875,0,0,1-1.273-2.233V62.136",
    transform: "translate(332.479 223.556)",
    fill: "none",
    stroke: "#fdfbe3",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTransaction);
export default __webpack_public_path__ + "static/media/pending-transaction.bd4bf27b1a49baa3c48b973b8acf9c8c.svg";
export { ForwardRef as ReactComponent };